import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../Utility/API";
import toast from "react-hot-toast";
import { updateAuth } from "../../Redux/AuthSlice";
import Fleg from "../../Assets/Header/Flag.png";
import { Link, useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import SidebarFIX from "../Sidebar/SidebarFIX";
import logo from "../../Assets/Images/logo.png";
import IconA from "../../Assets/sidebar/icon1.png";
import "./Activation.css";
import Eye from "../../Assets/Dasahboard/eye-slash.png";

export default function ActivateALGOTRADING() {
  const { userId, jwtToken } = useSelector((state) => state.Auth);
  const [dash, setdataArray] = useState([]);
  let [Amount, setAmount] = useState(0);
  let [loading, setloading] = useState(false);

  const [USDTBalance, setUSDTBalance] = useState(0);
  const [TopUpStatus, setTopUpStatus] = useState(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const GetUserDetails = async () => {
    try {
      let responce = await API?.post(
        "userdashboard",
        {
          uid: userId,
          type: 1,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
          },
        }
      );
      responce = responce.data.data[0];
      setdataArray(responce);

      // setTopUpStatus(responce.FixTradingActivestatus);
      setUSDTBalance(responce.Net_AdminFund);
    } catch (e) {
      console.log("userDetails error", e);
      // console.log("userDetails error", e.response.data);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(
          updateAuth({
            wtcAuth: false,
            token: null,
            userId: null,
            ipAddress: null,
          })
        );
        navigate("/");
      }
    }
  };

  
    const [downUserId, setdownUserId] = useState(userId);
    const [UserName, setUserName] = useState(userId);
  
    const getresponseId = async (valueee) => {
      const newValue = valueee.replace(/[^0-9]/gi, "");
      if (newValue === "") {
        setdownUserId("");
        setUserName("");
        setTopUpStatus(0);
      } else {
        setUserName(newValue);
        setdownUserId(newValue);
  
        let responce = await API?.post(
          "GetUserIdData",
          {
            loginId: userId,
            uid: newValue,
          },
          {
            headers: {
              Authorization: `${jwtToken}`,
            },
          }
        );
  
        let responseOut = responce?.data?.dataOut?.result;
        let response = responce?.data?.data;
  
        // console.clear();
        // console.log("responseOut-->", responseOut);
        // console.log("response-->", response);
        if (responseOut === "Valid User Id") {
          setTopUpStatus(response[0]?.AlgoSt);
          setUserName(response[0]?.f_name);
        } else {
          setTopUpStatus(0);
          setUserName(responseOut);
        }
      }
    };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Toggle sidebar function
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Loader component
  const Loader = () => (
    <div className="loader text-center">
      <Spinner animation="border" variant="primary" />
      <p>Loading...</p>
    </div>
  );

  const Loader2 = () => (
    <div className="loader text-center">
      <Spinner animation="border" variant="primary" />
      <p>
        <button className="activate_btn">
          Wait for 15 minutes after last transaction
        </button>
      </p>
    </div>
  );

  const CalculateValue = (val) => {
    const Addvalues = val;
    const Totalvalue = parseFloat(Addvalues) + parseFloat(Amount);
    setAmount(Totalvalue);
  };

  const ActivateUpgrade = async (e) => {
    if (parseFloat(Amount) < parseFloat(100)) {
      toast.error(
        "Amount Limit for Activate/Upgrade is: Minimum- $100, Maximum- $2400 And Should be in multiple of 100"
      );
      return;
    } else if (parseFloat(Amount) > parseFloat(2400)) {
      toast.error(
        "Amount Limit for Activate/Upgrade is: Minimum- $100, Maximum- $2400 And Should be in multiple of 100"
      );
      return;
    } else if (parseFloat(Amount) % 100 !== 0) {
      toast.error(
        "Amount Limit for Activate/Upgrade is: Minimum- $100, Maximum- $2400 And Should be in multiple of 100"
      );
      return;
    } else if (parseFloat(Amount) > parseFloat(USDTBalance)) {
      toast.error(
        "Insufficient Wallet Balance, Required: " +
          Amount +
          ", Balance:" +
          USDTBalance
      );
      return;
    } else {
      let res = await API.post(
        "Activation_FIX_TRADING",
        {
          uid: userId,
          user_id: downUserId,
          type: "FUNDS",
          referby: userId,
          amount: Amount,
          actype:parseInt(TopUpStatus) === 0 ? "Activation" : "Upgrade",
          islvl: 1,
        },
        {
          headers: {
            Authorization: `${jwtToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("res-->", res);

      if (
        res.data.data.RESULT === "Successfully Activated...!!!" ||
        res.data.data.RESULT === "Successfully upgraded...!!!"
      ) {
        if (TopUpStatus === "Inactive") {
          toast.success("Successfully Activated!");
        } else {
          toast.success("Successfully upgraded");
        }
        navigate("/DashboardFIX");
      } else {
        toast.error(res.data.data.RESULT);
        return;
      }
    }
  };

  //Notification start
  // const [NotificationCount, setNotificationCount] = useState("");
  // const getNotification = async () => {
  //   try {
  //     let res = await API.get(`/GetNotificationuserCount?uid=${userId}`);
  //     setNotificationCount(res.data.data.result);
  //   } catch (e) {
  //     console.log("Error", e);
  //   }
  // };
  // Notification end

  useEffect(() => {
    GetUserDetails();
    getresponseId(userId);
  }, []);

  return (
    <>
      <div className="container-fluid NewDashboard">
        <div className="row">
          <div
            className={` ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
          >
            <SidebarFIX />
          </div>
          <div className="col-lg-2 px-0 order-2">
            <div className="sidebarLeft px-3 position-relative">
              <div className="leftisidelogo">
                <img className="h-100 w-100" src={logo} alt="" />
              </div>
              <ul className="itemssidebar">
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    FIX Investment
                  </Link>
                  {dash?.Fixpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    ALGO TRADING Investment
                  </Link>
                  {dash?.FixTradingpackage}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    ADV. TRADING Investment
                  </Link>
                  {dash?.FixAdvTradingpackage}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Total Income
                  </Link>
                  ${dash.TotalIncome}
                </li>
                <li>
                  <Link
                    to=""
                    className="Anker w-100"
                    id="txtchangevalue"
                    value="Withdrawal"
                    // onClick={() => OnHandleWithdrawalLink()}
                  >
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Withdrawal Amount
                  </Link>
                  ${dash.WithDrawal_Amount}
                </li>
                <li>
                  <Link className="Anker" to="">
                    <div className="icon">
                      <img className="w-100 h-100" src={IconA} alt="" />
                    </div>{" "}
                    Net Balance
                  </Link>{" "}
                  ${dash?.Net_Balance}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-10 px-0 order-lg-2 order-1">
            <div className="contentside">
              <div className="row mx-0">
                <div className="col-12 px-0">
                  <header className="header ps-0">
                    <div className="hdleft d-flex align-items-center">
                      <div className="namelogo ps-3"></div>
                    </div>
                    <div className="rightside">
                      <div className="dropdown dropdow2 d-none d-md-block">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="text1">
                            <p className="mb-1">ID Number</p>
                            <p className="mb-0 fw-bold text-start">{userId} </p>
                          </span>
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu p-2">
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <div className="dropdown dropdow2 d-block d-md-none">
                        <Link
                          className="btn btnsecondary dropdown-toggle"
                          to=""
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="icon">
                            <div className="name">
                              <img className="w-100 h-100" src={logo} alt="" />
                            </div>
                          </span>
                        </Link>

                        <ul className="dropdown-menu">
                          <li>
                            <Link className="dropdown-item" to="#">
                              Id Number <span>{userId}</span>
                            </Link>
                          </li>
                          <li className="text-white walltadd">
                            {dash?.f_name}
                          </li>
                        </ul>
                      </div>
                      <a href="/DashboardBOT">
                        <button className="btn headerbtn">MAGIC PLAN</button>
                      </a>
                      <button
                        className="btn border-0 togglebtn"
                        id="togglebtn"
                        onClick={toggleSidebar}
                      >
                        <i
                          className={`fas fa-bars text-white ${
                            isSidebarOpen ? "" : "collapsed"
                          }`}
                        ></i>
                      </button>
                    </div>
                  </header>
                </div>
              </div>
              <div className="row mx-0">
                <div className="col-lg-3"></div>
                <div className="col-lg-6">
                  <div className="card leftsidecardpoint">
                    <div className="card-body">
                      <div className="card-heading ">
                        ALGO TRADING Plan Activate /Upgrade
                      </div>
                      <div className="" role="document">
                        <div className="modal-content10">
                          <div className="" style={{ paddingBottom: 10 }}>
                            <div className="avlbal">
                              <div className="Model_text_inner activation_Item">
                                <div className="rate_item text-white">
                                  <span className="text-black fs-5">
                                    {" "}
                                    Available Balance : ${USDTBalance}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="activation_modal">
                            <div className="popup_net">
                              <div className="addNum">
                              <div className="trxnumber text-black fs-5">
                                  <span
                                    className="text-black"
                                    style={{ marginLeft: 10 }}
                                  >
                                    User Id
                                  </span>
                                  <br />
                                  <input
                                    type="text"
                                    readOnly=""
                                    value={downUserId}
                                    onChange={(e) => {
                                      getresponseId(e.target.value);
                                    }}
                                    id="txtamount2"
                                    className="form5"
                                    defaultValue={0}
                                  />
                                </div>
                                <div className="trxnumber text-black fs-5">
                                  <span
                                    className="text-black"
                                    style={{ marginLeft: 10 }}
                                  >
                                    Name
                                  </span>
                                  <br />
                                  <input
                                    type="text"
                                    readOnly=""
                                    value={UserName}
                                    id="txtamount2"
                                    className="form5"
                                  />
                                </div>
                                <div className="trxnumber text-black fs-5">
                                  <span
                                    className="text-black"
                                    style={{ marginLeft: 10 }}
                                  >
                                    Package Amount
                                  </span>
                                  <br />
                                  <input
                                    type="text"
                                    readOnly=""
                                    value={Amount}
                                    id="txtamount2"
                                    className="form5"
                                    defaultValue={0}
                                  />
                                </div>

                                <div className="btn-list btn_set_item d-flex justify-content-center mb-3 flex-wrap">
                                  <button
                                    onClick={() => CalculateValue(100)}
                                    className="btn btn-sm btn-primary text-black fs-4"
                                  >
                                    {" "}
                                    $ 100
                                  </button>
                                  <button
                                    onClick={() => CalculateValue(500)}
                                    className="btn btn-sm btn-primary text-black fs-4"
                                  >
                                    {" "}
                                    $ 500
                                  </button>
                                  <button
                                    onClick={() => CalculateValue(1000)}
                                    className="btn btn-sm btn-primary text-black fs-4"
                                  >
                                    {" "}
                                    $ 1000
                                  </button>
                                  <button
                                    onClick={() => setAmount(0)}
                                    className="btn btn-sm btn-primary text-black fs-4"
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <div
                                    className="trxnumber"
                                    style={{ textAlign: "center" }}
                                  >
                                    {loading == true ? (
                                      <>
                                        <Loader />
                                      </>
                                    ) : (
                                      <>
                                        <>
                                          {parseInt(TopUpStatus) === 1? (
                                            <button
                                              className="viewalls"
                                              onClick={() => ActivateUpgrade()}
                                            >
                                              Upgrade
                                            </button>
                                          ) : (
                                            <button
                                              className="viewalls"
                                              onClick={() => ActivateUpgrade()}
                                            >
                                              Activate
                                            </button>
                                          )}
                                        </>
                                      </>
                                    )}
                                  </div>
                                  <p style={{ color: "red" }}>
                                    **Amount limit for activate/upgrade in ALGO
                                    TRADING Plan is: Minimum- $100, Maximum-
                                    $2400 and should be in multiple of 100.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
